import { render, staticRenderFns } from "./TodoItemComponent.vue?vue&type=template&id=e2374536"
import script from "./TodoItemComponent.vue?vue&type=script&lang=js"
export * from "./TodoItemComponent.vue?vue&type=script&lang=js"
import style0 from "./TodoItemComponent.vue?vue&type=style&index=0&id=e2374536&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports